import {send} from "../../../components/fetchData";

let debugPayments = (dataError) => {
  let data = {
    module: 'debug_pay',
    data: dataError
  }

  send
    .post("unregistered.php", data)
    .then((response) => {
      console.log('Успех debug Payments', response);
    })
    .catch((error) => {
      console.log(error)
    })
};

export { debugPayments }